export default "__VITE_ASSET__DXgolQW5__"